module.exports = __webpack_public_path__ + "img/download-ios.2870b141.webp";